export default __webpack_public_path__ + "static/media/balmain_5.63b63a77.jpg";